import { z } from 'zod'

import { ShippingAddressFormSchema } from 'Components/ShippingAddressForm/ShippingAddressForm.types'

import { getRental_rental } from 'Constants/graphql/queries/detail/__generated__/getRental'

import { replaceBrokenDeviceSummarySchema } from './ReplaceBrokenDeviceModal.schema'

export type ReplaceBrokenDeviceModalProps = {
  handleSubmit: () => void
  onClose: () => void
  rental: getRental_rental
}

export type ReplaceBrokenDeviceShippingFormProps = {
  rental: getRental_rental
  shippingFormData: ShippingAddressFormSchema | null
  onCancel: () => void
  onSetCurrentStep: (
    step: `${ReplaceBrokenDeviceModalStepsEnum}`,
    shippingData?: ShippingAddressFormSchema,
  ) => void
}

export type ReplaceBrokenDeviceSummaryProps = {
  rental: getRental_rental
  shippingFormData: ShippingAddressFormSchema | null
  onSetCurrentStep: (
    step: `${ReplaceBrokenDeviceModalStepsEnum}`,
    shippingData?: ShippingAddressFormSchema,
  ) => void
  onSubmit: () => void
}

export enum ReplaceBrokenDeviceModalStepsEnum {
  'SHIPPING' = '1',
  'SUMMARY' = '2',
}

export type ReplaceBrokenDeviceModalStepsMap = {
  [key: string]: {
    component: React.FunctionComponent<any>
    props: any
  }
}

export type ReplaceBrokenDeviceSummarySchema = z.infer<
  typeof replaceBrokenDeviceSummarySchema
>
